import React, { useCallback, useState } from 'react'
import uniqueId from 'lodash/uniqueId'

import { Alert, Unique } from './snackbar.types.ts'
import { Snackbar } from './snackbar.tsx'
import { MAX_SNACKS, SnackbarContext } from './snackbar.context.ts'

export const SnackbarProvider = ({ children }: React.PropsWithChildren<unknown>): React.ReactElement => {
  const [snacks, setSnacks] = useState<Array<Unique<Alert>>>([])
  const addSnack = useCallback((alert: Alert) => {
    const newAlert: Unique<Alert> = { id: uniqueId(), timeout: 3000, closeIcon: true, ...alert, visible: true }

    setSnacks((snacks) => {
      let newSnacks = [...snacks, newAlert]
      if (snacks.length >= MAX_SNACKS) {
        const removePosition = snacks.length - MAX_SNACKS + 1

        // скрываем самые старые уведомления
        newSnacks = newSnacks.map((snack, idx) => ({
          ...snack,
          visible: idx < removePosition ? false : snack.visible,
        }))
      }

      return newSnacks
    })

    return newAlert
  }, [])

  const hideSnack = useCallback((id: string) => {
    setSnacks((snacks) =>
      snacks.map((snack) => ({
        ...snack,
        visible: snack.id === id ? false : snack.visible,
      }))
    )
  }, [])

  const removeHidden = useCallback(() => {
    setSnacks((snacks) => snacks.filter((snack) => snack.visible))
  }, [])

  return (
    <SnackbarContext.Provider value={{ snacks, addSnack, hideSnack, removeHidden }}>
      {children}
      <Snackbar />
    </SnackbarContext.Provider>
  )
}
